export default "__VITE_ASSET__COCHT$fC__"